import type SearchViewState from '../store/schema/SearchViewState';
import { getFilePickerStore } from '../store/filePickerStore';
import { mutator } from 'satcheljs';
import { clearSearchBox } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';

export const exportOnlyForTest = mutator(clearSearchBox, actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.FilesPicker) {
        return;
    }

    const searchViewState: SearchViewState = getFilePickerStore().viewState.filePickerViewState
        .searchViewState;
    searchViewState.searchQuery = '';
    searchViewState.isInSearchMode = false;
});
